var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCsv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 4.25V0H0.75C0.3125 0 0 0.34375 0 0.75V15.25C0 15.6875 0.3125 16 0.75 16H11.25C11.6562 16 12 15.6875 12 15.25V5H7.75C7.3125 5 7 4.6875 7 4.25ZM4 8.75C4 8.90625 3.875 9 3.75 9H3.5C3.21875 9 3 9.25 3 9.5V10.5C3 10.7812 3.21875 11 3.5 11H3.75C3.875 11 4 11.125 4 11.25V11.75C4 11.9062 3.875 12 3.75 12H3.5C2.65625 12 2 11.3438 2 10.5V9.5C2 8.6875 2.65625 8 3.5 8H3.75C3.875 8 4 8.125 4 8.25V8.75ZM5.375 12H5C4.84375 12 4.75 11.9062 4.75 11.75V11.25C4.75 11.125 4.84375 11 5 11H5.375C5.5625 11 5.6875 10.9062 5.6875 10.8125C5.6875 10.7812 5.65625 10.7188 5.625 10.6875L4.9375 10.0938C4.6875 9.875 4.53125 9.5625 4.53125 9.21875C4.53125 8.5625 5.125 8.03125 5.84375 8.03125H6.25C6.375 8.03125 6.5 8.125 6.5 8.28125V8.78125C6.5 8.90625 6.375 9.03125 6.25 9.03125H5.84375C5.65625 9.03125 5.53125 9.125 5.53125 9.21875C5.53125 9.25 5.5625 9.3125 5.59375 9.34375L6.28125 9.9375C6.53125 10.1562 6.6875 10.4688 6.6875 10.8125C6.6875 11.4688 6.09375 12 5.375 12ZM8 8.25V8.90625C8 9.5625 8.15625 10.1562 8.5 10.6875C8.8125 10.1562 9 9.5625 9 8.90625V8.25C9 8.125 9.09375 8 9.25 8H9.75C9.875 8 10 8.125 10 8.25V8.90625C10 10.0312 9.59375 11.0625 8.84375 11.8438C8.75 11.9688 8.625 12 8.5 12C8.34375 12 8.21875 11.9688 8.125 11.8438C7.375 11.0625 7 10.0312 7 8.90625V8.25C7 8.125 7.09375 8 7.25 8H7.75C7.875 8 8 8.125 8 8.25ZM11.7812 3.28125L8.71875 0.21875C8.5625 0.09375 8.375 0 8.1875 0H8V4H12V3.8125C12 3.625 11.9062 3.4375 11.7812 3.28125Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsv);
export default __webpack_public_path__ + "static/media/csv.0298b378ebd293440a040780c58707cd.svg";
export { ForwardRef as ReactComponent };